import { prefersTouchWording, subscribeTouchWording } from '@/lib/cornerstone/touchVocabulary';
import { useSyncExternalStore } from 'react';
/**
 * True when viewer guidance should speak touch ("tap", "long-press") rather
 * than mouse ("click", "right-click"): any coarse pointer on the device, so a
 * Windows touch laptop gets it too. Re-renders when that changes (a tablet
 * docked or undocked). The one hook every hint, label and guide uses, so the
 * wording never disagrees between two parts of the same screen.
 */
export function useTouchWording() {
    return useSyncExternalStore(subscribeTouchWording, prefersTouchWording, () => false);
}
